import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MessageComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rti-error-messages-wrapper',
  templateUrl: './error-messages-wrapper.component.html',
  styleUrls: ['./error-messages-wrapper.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent],
})
export class ErrorMessagesWrapperComponent {
  @Input() public errors: string[] = [];

  public trackByErrorMessage(_index: number, error: string): string {
    return error;
  }
}
